var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAncientGreekIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.003 512.003",
    style: {
      enableBackground: "new 0 0 512.003 512.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 126.555,
    y: 44.143,
    style: {
      fill: "#BAC6CC"
    },
    width: 258.884,
    height: 33.388
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#CFDCE5"
    },
    points: "385.445,131.242 385.445,470.257 126.563,470.257 126.563,131.242 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BAC6CC"
    },
    points: "158.548,131.242 158.548,470.257 126.563,470.257 126.563,131.242  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#BAC6CC"
    },
    points: "385.445,131.242 385.445,183.749 126.563,183.749 126.563,131.242  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 116.636,
    style: {
      fill: "#CFDCE5"
    },
    width: 278.734,
    height: 44.143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.636,
    y: 470.26,
    style: {
      fill: "#CFDCE5"
    },
    width: 278.734,
    height: 41.743
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 116.636,
    style: {
      fill: "#BAC6CC"
    },
    width: 66.388,
    height: 44.143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.636,
    y: 470.26,
    style: {
      fill: "#BAC6CC"
    },
    width: 66.388,
    height: 41.743
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDCE5"
    },
    d: "M430.376,96.123c-12.397-12.397-28.646-18.597-44.905-18.597h-129.47H126.53 c-16.259,0-32.507,6.199-44.905,18.597c-19.831,19.841-19.831,51.999,0,71.84c15.871,15.871,41.602,15.871,57.472,0 c4.496-4.496,7.392-9.983,8.704-15.758l0,0h216.245l0.12-0.167c1.293,5.835,4.201,11.385,8.74,15.923 c15.871,15.871,41.602,15.871,57.472,0C450.207,148.123,450.207,115.964,430.376,96.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CC"
    },
    d: "M401.641,186.693c-12.161,0-24.321-4.629-33.578-13.887c-7.434-7.434-11.529-17.318-11.529-27.832 s4.094-20.399,11.529-27.832c6.207-6.207,14.459-9.626,23.234-9.626c8.777,0,17.027,3.42,23.229,9.628 c2.673,2.676,2.671,7.012-0.005,9.685c-2.674,2.673-7.012,2.672-9.685-0.006c-3.615-3.618-8.423-5.611-13.539-5.611 c-5.117,0-9.928,1.994-13.549,5.614c-4.848,4.847-7.517,11.291-7.517,18.147c0,6.854,2.669,13.3,7.517,18.147 c13.175,13.175,34.611,13.175,47.786,0c17.127-17.136,17.127-45.019-0.001-62.156c-10.698-10.698-24.925-16.59-40.061-16.59H126.53 c-15.136,0-29.363,5.892-40.062,16.591c-17.127,17.136-17.127,45.019,0.001,62.156c13.174,13.174,34.61,13.174,47.785-0.001 c4.848-4.847,7.517-11.292,7.517-18.147c0-6.856-2.669-13.3-7.517-18.147c-3.62-3.62-8.432-5.614-13.549-5.614 c-5.116,0-9.924,1.993-13.539,5.611c-2.672,2.677-7.01,2.678-9.685,0.006c-2.677-2.673-2.679-7.01-0.006-9.685 c6.203-6.208,14.452-9.628,23.23-9.628c8.776,0,17.027,3.419,23.234,9.626c7.434,7.434,11.529,17.318,11.529,27.832 s-4.094,20.399-11.529,27.832c-18.516,18.516-48.642,18.516-67.157,0c-22.466-22.478-22.466-59.048-0.001-81.524 c13.287-13.287,30.954-20.603,49.748-20.603h258.942c18.794,0,36.462,7.317,49.748,20.602c22.466,22.478,22.466,59.048,0.001,81.524 C425.962,182.063,413.801,186.692,401.641,186.693z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB8BC"
    },
    d: "M229.181,249.379v220.873h-58.215V249.379c0-12.773,8.241-23.628,19.69-27.532 c2.956-1.027,6.118-1.575,9.417-1.575C216.145,220.272,229.181,233.307,229.181,249.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB8BC"
    },
    d: "M341.044,249.379v220.873H282.83V249.379c0-12.773,8.241-23.628,19.69-27.532 c2.956-1.027,6.118-1.575,9.417-1.575C328.009,220.272,341.044,233.307,341.044,249.379z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CC"
    },
    d: "M210.347,249.379v220.873h-39.38V249.379c0-12.773,8.241-23.628,19.69-27.532 C202.105,225.749,210.347,236.606,210.347,249.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CC"
    },
    d: "M322.21,249.379v220.873h-39.38V249.379c0-12.773,8.241-23.628,19.69-27.532 C313.969,225.749,322.21,236.606,322.21,249.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CC"
    },
    d: "M372.554,77.526c-15.581,0.297-30.82,5.148-43.456,14.291 c-20.957,15.181-46.732,24.131-74.606,24.131s-53.649-8.949-74.606-24.131c-12.636-9.143-27.875-13.994-43.456-14.291H372.554z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAncientGreekIcon);
export default __webpack_public_path__ + "static/media/ancient_greek_icon.592ffcaa5ca620dccac80eb0a770beee.svg";
export { ForwardRef as ReactComponent };